import cloneDeep from 'lodash/cloneDeep';

import moment from 'moment';
import qs from 'qs';

import { handleActions } from 'redux-actions';
import axios from 'axios';
import endpoints from '../../config/endpoints';
import intl from '../shared/intl';
import checkPermissions from '../shared/check-permissions';
import { default as createCalendar, getDateRangeFromCalendar } from '../shared/calendar';
import { actions as rootActions } from '../root';

const calendar = createCalendar({
	namespace: 'promoReports',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment()
			.subtract('1', 'month')
			.format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

export const allowedPermissions = {
	'promo_report_view': 'promo_report_view'
};

// actions types
const FETCH_DATA_SUCCESS = 'promo-reports/fetch-data-success';
const TOGGLE_PROGRESS_BAR = 'promo-reports/toggle-progress-bar';

const GET_PROMO_REPORTS_SUCCESS = 'promo-reports/get-report-success';
const GET_PROMO_REPORTS_ERROR = 'promo-reports/get-report-error';

// permissions

// initial state
const initialState = {
	data: null,
	calendar: calendar.initialState,
	showProgressBar: false,
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => dispatch => {
			setTimeout(() => dispatch({ type: FETCH_DATA_SUCCESS }), 1);
		},
		getConversionReport: () => dispatch => dispatch(actions.getReport(endpoints.PROMO_REPORTS.CONVERSION)),

		getReport: (baseUrl) => (dispatch, getState) => {
			const { calendar } = getState().promoReports;
			const date_range = getDateRangeFromCalendar(calendar);
			const url = `${baseUrl || endpoints.PROMO_REPORTS.BASE}/?${qs.stringify({ date_range })}`;

			dispatch(rootActions.spinnerToggle());
			return axios({
				url,
				method: 'GET',
				responseType: 'blob'
			}).then((response) => {
				dispatch(rootActions.spinnerToggle());
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				const startDate = moment(date_range.start).format('DD.MM.YYYY');
				const endDate = moment(date_range.end).format('DD.MM.YYYY');
				const filename = `Отчет за период с ${startDate} по ${endDate}.csv`;
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
			})
				.catch(() => {
					dispatch(rootActions.spinnerToggle());
				});
		},

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	},
	calendar.actions
);

// reducers
const reducers = Object.assign(
	{
		// placeholder data needed because of state machine and init func = fetchData
		[FETCH_DATA_SUCCESS]: (state, action) => ({ ...state, data: 'placeholder' }),
		[GET_PROMO_REPORTS_SUCCESS]: (state, action) => ({ ...state, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[GET_PROMO_REPORTS_ERROR]: state => ({ ...state, error: true })
	},
	calendar.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.promoReports.data,
	getCalendar: state => calendar.selectors.getCalendar(state => state.promoReports.calendar, state => state)(state),
	getIntl: state => intl(state),
	getProgressBar: state => state.promoReports.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.promoReports.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/promo-reports/index.js